// Shared by the two pages of the jewellery demo for BlueBird (November 2026): two chats of one
// tenant on Kodly-hosted QA, built from BlueBird's own feed and bluebird.pt (demos/bluebird in the
// workspace). The paths carry no client name and are not linked from anywhere. The tokens are
// public by design, as in the retail demo. The loader hook is the retail demo's.
export { useKodlyLoader } from "./retailDemo";

export const JEWELLERY_DEMO_PATH = "/p/Pbusb68_Lm4";
export const COPILOT_TOKEN = "pk_kodly_live_JNNQWqSe9kjpi8PGANi49dt53r7AldNl";
export const CUSTOMER_TOKEN = "pk_kodly_live_x5M4EPGPXJZKpC-PL9kaKko9fTBTNmD6";
